import React, { FunctionComponent } from 'react';
import { Navigate, Route, Routes } from 'react-router';

import { useGetShopStatusQuery } from 'src/api/@generated/backend-api';

import { ProtectedRoute } from 'src/components/protected--route';
import { Spinner } from 'src/components/spinner';
import { ChooseAccountPage } from 'src/pages/choose-account/choose-account-page';
import { ChooseServiceLocationPage } from 'src/pages/choose-service-location/choose-service-location-page';
import { Store } from 'src/pages/store';
import { NavigationService } from 'src/services/navigation-service';
import { selectSelectedAccount } from 'src/state/account/selectors';
import { selectServiceLocation } from 'src/state/address/selectors';
import { useAppSelector } from 'src/state/thunk-api';

export const StoreRoutes: FunctionComponent = () => {
  const selectedAccount = useAppSelector(selectSelectedAccount);
  const selectedServiceLocation = useAppSelector(selectServiceLocation);
  const { data: shopStatus, isLoading } = useGetShopStatusQuery();

  if (isLoading) {
    return <Spinner />;
  }

  if (!shopStatus?.enabled) {
    return <Navigate to={NavigationService.ERROR_UNDER_MAINTENANCE} replace={true} />;
  }

  return (
    <Routes>
      <Route path={NavigationService.CHOOSE_ACCOUNT} element={<ChooseAccountPage />} />
      <Route path={NavigationService.CHOOSE_SERVICE_LOCATION} element={<ChooseServiceLocationPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute
            isProtected={() => !selectedAccount || !selectedServiceLocation}
            redirectTo={NavigationService.CHOOSE_ACCOUNT}
          >
            <Store />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};
